import React, { useEffect, useState } from "react";
import profile from "../assets/uicon.png";
import { sendNotification, updateTransactions } from "../firebase/firebase";
import { getDueDate, payEmployee } from "../web3hooks/contracthooks";
import toast from "react-hot-toast";

const Sign_modal = ({ visible, onClose, companies, type, values }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [processing, setProcessing] = useState("submit");
  const handleOnClose = (e) => {
    if (e.target.id === "container") onClose();
  };

  const [details, setDetails] = useState();
  // employee blockchain details
  const [employee, setEmployee] = useState({
    dueDate: "",
    currentDate: "",
    startDate: "",
    due: false,
  });

  console.log("company", companies);
  console.log("values", values);

  // get due date
  const checkDueDate = async () => {
    const { startDate, dueDate, currentDate, due } = await getDueDate(
      companies?.companyAddy,
      companies?.payId
    );
    setEmployee({
      dueDate: dueDate.toString(),
      currentDate: currentDate.toString(),
      due: due,
      startDate: startDate.toString(),
    });
  };

  // send complaints
  const sendComplaints = async (e) => {
    const notification = toast.loading("⏳Sending message");
    setIsClicked(true);
    setProcessing("processing");
    e.preventDefault();
    if (!type) {
      console.log(
        companies?.companyAddy,
        values?.email,
        values?.logo,
        values?.name,
        details
      );
      const { sent } = await sendNotification(
        companies?.companyAddy,
        values?.email,
        values?.businessLogoUrl,
        values?.name,
        details
      );
    } else {
      console.log(
        companies?.email,
        values?.email,
        values?.businessLogoUrl,
        values?.name,
        details
      );
      await sendNotification(
        companies?.email,
        values?.email,
        values?.businessLogoUrl,
        values?.name,
        details
      );
    }
    setIsClicked(false);
    toast.success("✅Message sent!", {
      id: notification,
    });
    setProcessing("submit");
  };

  // pay employee

  const pay = async () => {
    try {
      const notification = toast.loading("⏳ Processing transaction....");
      const tronweb = window.tronWeb;
      const contract = await tronweb
        .contract()
        .at("TDrxc8oPALmdgLKpnfhQThQvh71QzG3A2p");

      const pay = await tronweb.toSun(companies?.salary);
      const hash = await contract
        .pay(companies?.companyAddy, companies?.payId)
        .send({
          feeLimit: 100_000_000,
          callValue: pay,
        });

      toast.loading("⏳ Paying Employee...", {
        id: notification,
      });
      console.log(hash);
      setTimeout(async () => {
        await updateTransactions(
          values?.address,
          {
            address: companies?.companyAddy,
            amount: companies?.salary,
          },
          hash,
          true
        );
        toast.success("✅ Payment Done", {
          id: notification,
        });
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!type) {
      checkDueDate();
    }
  }, []);

  if (!visible) return null;

  return (
    <div
      id="container"
      onClick={handleOnClose}
      className="fixed inset-0 z-50 bg-black bg-opacity-30 backdrop-blur-[1px] flex justify-center items-center"
    >
      <div className="bg-[#434242] p-2 rounded lg:w-2/4 mx-auto h-2/3 py-5">
        {type ? (
          <form
            onSubmit={sendComplaints}
            className="h-full w-full mx-auto px-8 rounded-lg space-y-2"
          >
            <h2 className="text-3xl font-bold text-center dark:text-white font-Varela">
              Company Details
            </h2>
            <div className="grid grid-cols-3 space-x-3">
              <div className="col-span-1">
                {companies?.businessLogoUrl ? (
                  <>
                    <img
                      src={companies?.businessLogoUrl}
                      alt="profile"
                      className="w-2/3  rounded-md"
                    />
                  </>
                ) : (
                  <img
                    src={profile}
                    alt="profile"
                    className="w-2/3  rounded-md"
                  />
                )}
              </div>
              <div className="space-y-3 text-lg col-span-2 font-semibold">
                <p>
                  Company Name:{" "}
                  <span className="font-thin">{companies?.companyName}</span>
                </p>
                <p>
                  Company Address:{" "}
                  <span className="font-thin">
                    {companies?.companyAddress}
                    {companies?.selectedCountry}
                  </span>
                </p>
                <p>
                  Company Type:{" "}
                  <span className="font-thin"> {companies?.businessType}</span>
                </p>
                <div>
                  <p>Contact Us</p>
                  <p>
                    Phone:{" "}
                    <span className="font-thin">{companies?.telephone}</span>
                  </p>
                  <p>
                    Website:{" "}
                    <span className="font-thin">{companies?.website}</span>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className=" space-y-1">
                <label className="text-xs font-normal py-2 leading-4">
                  Leave us a message
                </label>
                <input
                  id="des"
                  type="text"
                  className="py-2 text-black w-full h-[4rem] p-2 text-sm"
                  name="des"
                  placeholder="Leave us a message"
                  onChange={(e) => setDetails(e.target.value)}
                  required
                />
                <button
                  type="submit"
                  disabled={isClicked}
                  className="py-2 px-5 rounded-sm"
                >
                  {processing}
                </button>
              </div>
            </div>
          </form>
        ) : (
          <div className="h-full w-full mx-auto px-8 rounded-lg space-y-2">
            <h2 className="text-3xl font-bold text-center dark:text-white font-Varela">
              Role in {companies?.company}
            </h2>
            <div className="grid grid-cols-3 space-x-3">
              <div className="col-span-1">
                {companies?.logo ? (
                  <>
                    <img
                      src={companies?.logo}
                      alt="profile"
                      className="w-2/3  rounded-md"
                    />
                  </>
                ) : (
                  <img
                    src={profile}
                    alt="profile"
                    className="w-2/3  rounded-md"
                  />
                )}
              </div>
              <div className="space-y-3 text-lg col-span-2 font-semibold">
                <p>
                  Company Name:{" "}
                  <span className="font-thin">{companies?.company}</span>
                </p>
                <p>
                  Role: <span className="font-thin">{companies?.role}</span>
                </p>
                <p>
                  Salary:{" "}
                  <span className="font-thin"> {companies?.salary}</span>
                </p>
                <p>
                  Start Date:{" "}
                  <span className="font-thin"> {employee.startDate}</span>
                </p>
                <p>
                  Pay Day:{" "}
                  <span className="font-thin"> {employee.dueDate}</span>
                </p>
              </div>
            </div>
            <div>
              {employee.due ? (
                <button
                  onClick={pay}
                  className="px-4 text-white bg-green-700 py-2 rounded my-2"
                >
                  Pay
                </button>
              ) : (
                <button
                  className="px-4 text-white py-2 bg-red-700 rounded my-2"
                  disabled
                >
                  Not yet due
                </button>
              )}
            </div>
            <form onSubmit={sendComplaints}>
              <div className=" space-y-1">
                <label className="text-xs font-normal py-2 leading-4">
                  Request for advance payment
                </label>
                <input
                  id="kkk"
                  type="text"
                  className="py-2 text-black w-full h-[4rem] p-2 text-sm"
                  name="kkk"
                  placeholder="Request for advance payment"
                  onChange={(e) => setDetails(e.target.value)}
                  required
                />
                <button
                  disabled={isClicked}
                  className="py-2 px-5 rounded-sm"
                  type="submit"
                >
                  {processing}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sign_modal;
